import React from 'react';
import { graphql } from 'react-apollo';
import { compose, defaultProps, withState, withHandlers } from 'recompose';
import { injectIntl } from 'react-intl';

import { FORGOT } from '../graphql/index';
import ForgottenPasswordCard from '../../components/forgottenPasswordCard/ForgottenPasswordCard';

/* eslint-disable react/prop-types */
const withData = (props) => {
  const resetPassword = (email) => {
    if (!props.loading) {
      props.toggleLoading();    // toggle loading
      props.toggleError(false); // disable error message
      props.mutate({ variables: { email } }).then(() => {
        props.toggleLoading();  // toggle loading
        props.toggleSent(true); // toggle sent message
      }).catch((error) => {
        const type = error.message.substring('GraphQL error: '.length).substring(0, 3);
        switch (type) {
          case '500':
            props.updateErrorMessage(props.intl.formatMessage({ id: 'login.error.emailNotFound' }));
            props.updateErrorIcon('question');
            props.toggleError(true);
            break;
          default:
            console.log(error); // eslint-disable-line no-console
            props.updateErrorIcon('ban');
            props.toggleError(true);
        }
        props.toggleLoading(); // toggle loading
      });
    }
  };
  return (
    <ForgottenPasswordCard
      askForPassword={resetPassword}
      {...props}
    />
  );
};

const enhance = compose(
  defaultProps({
    title: 'Recupere a sua senha',
    emailLabel: 'Email',
    buttonLabel: 'OK',
    errorTitle: 'Erro',
    backLabel: 'Voltar',
    backLink: '/',
    message: 'O link para alteração da sua senha foi enviado para o seu email.',
  }),
  withState('loading', 'toggleLoading', false),
  withState('error', 'toggleError', false),
  withState('errorIcon', 'updateErrorIcon', 'question'),
  withState('errorMessage', 'updateErrorMessage', 'O email não foi encontrado.'),
  withState('sent', 'toggleSent', false),
  withHandlers(
    {
      toggleLoading: props => () => {
        props.toggleLoading(!props.loading);
      },
      toggleError: props => (hasError) => {
        props.toggleError(hasError);
      },
      updateErrorIcon: props => (icon) => {
        props.updateErrorIcon(icon);
      },
      updateErrorMessage: props => (message) => {
        props.updateErrorMessage(message);
      },
      toggleSent: props => (sent) => {
        props.toggleSent(sent);
      },
    },
  ),
);

const CreateAccountContainer = enhance(injectIntl(withData));

export default graphql(FORGOT)(CreateAccountContainer);



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/apollo/containers/ForgottenPasswordContainer.js
 **/